import React from "react"
import clsx from "clsx"
import RoleBuilderErrors from "../RoleBuilderErrors"

export default class RoleBuilderSystemNotificationTypes extends React.Component {

  constructor(props) {
    super(props);

  }

  render() {

    var tabClasses = clsx({
      'active': this.props.active_tab == 'system_notification_types',
      'tab-pane': true
    });
    
    return (
      <div className={tabClasses} id="system_notification_types">
        {this.renderErrors()}
        {this.props.modifying_self && !this.props.read_only && !this.props.owner ? <div className="alert alert-warning text-center"><strong>{I18n.t('users_cannot_edit_their_own_system_notification_types')}</strong></div> : null}
        {this.props.owner && !this.props.modifying_self ? <div className="alert alert-warning text-center"><strong>{I18n.t('the_owner_role_cannot_be_modified')}</strong></div> : null}
        <div className="row">
          <div className="col-md-12">
            {this.renderSystemNotificationTypes()}
          </div>
        </div>
      </div>
    );
  }


  renderErrors() {
    var errors = RoleBuilderErrors.system_notification_types(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderSystemNotificationTypes() {
    if (this.props.system_notification_types && this.props.system_notification_types.length > 0) {
      var self = this;
      var system_notification_types = this.props.system_notification_types.map(function (system_notification_type) {
        var send_translation = system_notification_type.name == "text_messaging" ? I18n.t('send_text_notification_type') : I18n.t('send_system_notification_type')
        var show_translation = system_notification_type.name == "text_messaging" ? I18n.t('show_text_notification_type') : I18n.t('show_system_notification_type')
        return (
          <div key={system_notification_type.id} className="Role-system_notification_type form-horizontal">
            <div className="form-group">
              <div className="col-sm-2">
                <label className="control-label">{I18n.t(system_notification_type.name)}</label>
              </div>
              <div className="col-sm-10 permission-block">
                <div className="radio">
                    {<div><input type="radio" value="send_system_notification_type" name={system_notification_type.name} checked={self.hasAccess(system_notification_type, 'send_system_notification_type')} onChange={self.onChange.bind(self, system_notification_type, 'send_system_notification_type')} /> {send_translation}</div>}
                </div>
                <div className="radio">
                    {<div><input type="radio" value="show_system_notification_type" name={system_notification_type.name} checked={self.hasAccess(system_notification_type, 'show_system_notification_type')} onChange={self.onChange.bind(self, system_notification_type, 'show_system_notification_type')} /> {show_translation}</div>}
                </div>
                <div className="radio">
                    {<div><input type="radio" value="hide" name={system_notification_type.name} checked={self.hasAccess(system_notification_type, 'hide')} onChange={self.onChange.bind(self, system_notification_type, 'hide')} /> {I18n.t('hide')}</div>}
                </div>
              </div>
            </div>
          </div>
        );
      });

      return (
        <div className="system_notification_types">
          {system_notification_types}
        </div>
      );
    } else {
      return (
        <div className="text-center"><span className="none">{I18n.t('none')}</span></div>
      );
    }
  }

  hasAccess(system_notification_type, access) {
    // console.log(this.props.role_system_notification_types)
    var matched = false

    for (var i = 0, ilen = this.props.role_system_notification_types.length; i < ilen; i++) {
      // console.log(this.props.role_system_notification_types[i], )
      if (this.props.role_system_notification_types[i].system_notification_type_id == system_notification_type.id) {
        matched = this.props.role_system_notification_types[i]
      }
    }

    if (matched) {
      if (matched.access == access) {
        return true
      } else {
        return false
      }
    } else {
      if (access == "hide") {
        return true
      } else {
        return false
      }
    }
  }

  onChange(system_notification_type, access) {
    var role_system_notification_type = {
      system_notification_type_id: system_notification_type.id,
      access: access
    };

    // find matched system_notification_type index
    var matched_index = -1;
    for (var i = 0, ilen = this.props.role_system_notification_types.length; i < ilen; i++) {
      if (this.props.role_system_notification_types[i].system_notification_type_id == system_notification_type.id) {
        matched_index = i;
        break;
      }
    }

    if (matched_index >= 0) {
      // we have a match
      this.props.role_system_notification_types[matched_index] = role_system_notification_type;
    } else {
      // no match, so add new
      this.props.role_system_notification_types.push(role_system_notification_type);
    }

    this.props.onChangeSystemNotificationTypes(this.props.role_system_notification_types);
  }

};